import stock from './stock'

export default {
    namespaced: true,
        modules: {
            stock
    }
}
